module.exports = __webpack_public_path__ + "static/media/Uniform.0eef6ee6.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/content/chapters/01/01/assets/Uniform.jpeg
// module id = 350
// module chunks = 0